<template>

    <div class="short">
        <div v-if="loading">
            Loading customer...
        </div>
        <label v-else>
            <span class="label">Customer:</span>
            <div v-if="allCustomers" class="short">
                <!--<FormItem :name="'tags:'">-->
                <input :list="listId" v-model="selected" placeholder="type to search..." />

                <datalist :id="listId">
                    <option v-for="(item, index) in options" :key=index :value=item.invoiceName></option>
                </datalist>

                <!--</FormItem>-->
                <!--button class="rectangular" v-if="foundCustomer" type="button" @click="assignCustomer">assign</button-->
                <button v-if="foundCustomer" type="button"
                    @click="router.push(`/customers/${foundCustomer.id.toString()}`)">edit</button>
                <button v-else type="button" @click="router.push('/customers/create')">create</button>

            </div>
        </label>

    </div>

    <!--div class="debug" v-if="!loading">
      
        <p>Debugging Customer-listbox.vue:</p>
        <p>newProject prop = {{ props.newProject }}</p>
        <p>allCustomers count = {{ allCustomers.length }}</p>
        <p>selected = {{ selected }}</p>
        <p>customer.id = {{ customer.id }}</p>
        <p>customer.invoiceName = {{ customer.invoiceName }}</p>
        <p>customer obj = {{ customer }}</p>
        <p>foundCustomer = {{ foundCustomer }}</p>
        
    </div-->


</template>


<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useCustomerStore } from '@/stores';
import { storeToRefs } from 'pinia';
import type { Customer } from '@/types/types';
import router from '@/router';


const props = defineProps({
  newProject: { type: Boolean, default: false },
})



//import { storeToRefs } from 'pinia';
const customerStore = useCustomerStore();
const { allCustomers, loading } = storeToRefs(customerStore);
//const allCustomers = ref();
//allCustomers.value = await customerStore.getAllCustomers();
//const { allCustomers } = storeToRefs(customerStore);
/*
const loading = computed(()=>{
    return customerStore.loading;
})
*/

const customer = defineModel<Customer>('customer');
//is selected relevant?
const selected = ref(JSON.parse(JSON.stringify(customer.value.invoiceName)) || '');
/*const selected = computed(()=>{
    console.log("..Customer-listbox selected computed()...");
    //try{
        return JSON.parse(JSON.stringify(customer.value.invoiceName)) || '';
    //}catch(error){
    //    console.log("..Customer-listbox error parsing customer..");
    //    return '';
   //}
})*/
//watch selected from inputbox, emit changed to parent, pass customerId
/*watch(selected,()=>{
    console.log("..Customer-listbox watching selected fired...");
})*/
//const selected = ref('');
//await initCustomerField();
//customer.value = 'unknown';

//const allCustomers = ref<Array<Customer>>([]);

//TODO store fetcher on tagstore 

//generate random (hopefully unique) id
const listId = computed(() => {
    let x = Math.floor(Math.random() * 1000000 + 1)
    return `datalist-tags-${x}`
})

const options = computed(() => {
    if(props.newProject===true){
        return allCustomers.value.filter(cust=>{
            return cust.archived!=true;
        })
    }else{
        return allCustomers.value;
    }
    
})
const foundCustomer = ref(customer.value.id===null ? null : customer.value);
//const foundCustomer = computed(() => {
//    return customer.value.id===null ? null : customer.value;
//})
   /* try {
        return allCustomers.value.find((cust => {
            // console.log('..cust.invoiceName ' + cust.invoiceName);
            return cust.invoiceName === selected.value;
        }));
    } catch (error) {
        console.log("..error computing customerId")
        //return -1;
        return false;
    }

});*/
/*
function assignCustomer() {
    customer.value = foundCustomer;
}*/


watch(() => selected.value,
    (newVal, oldVal) => {
       // console.log('..customer listbox new.watch selected...newVal=' + newVal);
        const existing = allCustomers.value.map(cust=>{
            return cust.invoiceName;
        }).includes(newVal);
       // console.log('...existing =' + existing);
        if(existing){
            let matched= allCustomers.value.find((cust => {
                //console.log('..cust.invoiceName ' + cust.invoiceName);
                return cust.invoiceName === newVal;
            }));
            customer.value = matched;
            foundCustomer.value = matched;
           // console.log("....setting foundCustomer to customer...:" + JSON.stringify(customer.value));
            //foundCustomer.value = {id : customer.value.id, invoiceName : customer.value.invoiceName};
        }else{
            foundCustomer.value = false;
        }
/*
        try {
            customer.value = allCustomers.value.find((cust => {
                // console.log('..cust.invoiceName ' + cust.invoiceName);
                return cust.invoiceName === newVal;
            }));
        } catch (error) {
           //console.log("..error computing customerId")
            //return -1;
            //customer.value = '';
        }*/

    });





</script>

<style lang="css" scoped>
span.label {
    display: block;
    font-size: 0.875rem;
    line-height: 1.25rem;
}

div.short {
    width: 30rem;
    display: flex;
    flex-direction: row;
}

input {
    display: block;
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    background-color: white;
    border: 1px solid grey;


    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
    font-size: 1rem;
}

button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

button.rectangular {
    border-radius: 0;
    border-right-color: white;
    border-right-width: 1px;
}
.archived {
    color: red;
}
</style>